import { Button, Checkbox, Form, Input, Typography } from 'antd'
import { Rule } from 'antd/es/form';
import { Country } from 'entities/countries/model/types'
import { FC } from 'react'
import { useIntl } from 'react-intl';
import { PasswordHints } from './PasswordHints';
import { SignUpFormData } from 'pages/auth/registration/model/types';

type Props = {
  countries: Country[];
  formRules: Record<string, Rule[]>;
  formData: Partial<SignUpFormData>;
}

export const PasswordSection: FC<Props> = ({ countries, formRules, formData }) => {
  const { formatMessage: t } = useIntl();
  const [form] = Form.useForm();
  const passwordValue = Form.useWatch('password', form);
  const termsLink = ``;

  return (
    <Form form={form} name='password'>
      <Form.Item name='password' rules={formRules.password}>
        <Input.Password placeholder={t({ id: 'inputs.password.password' })} />
      </Form.Item>
      <Form.Item name='repeat_password' rules={[
        {
          required: true,
          message: t({ id: 'schemas.new.required-field' }),
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue('password') === value) {
              return Promise.resolve();
            }
            return Promise.reject(new Error(t({ id: 'schemas.password.match' })))
          }
        })
      ]}>
        <Input.Password placeholder={t({ id: 'inputs.password.repeat' })} />
      </Form.Item>
      <Form.Item>
        <PasswordHints value={passwordValue} regex={/.{8,}/} label={t({ id: 'password.hint3' })} />
        <PasswordHints value={passwordValue} regex={/\d/} label={t({ id: 'password.hint2' })} />
        <PasswordHints value={passwordValue} regex={/[a-zA-Z]/} label={t({ id: 'password.hint1' })} />
      </Form.Item>
      <Form.Item rules={[
        {
          validator: (_, value) =>
            value ? Promise.resolve() : Promise.reject(new Error(t({ id: 'schemas.new.required-field' }))),
        },
      ]} valuePropName="checked" name="privacyPolicy">
        <Checkbox id='btn__checkbox'>
          {t({ id: 'screens.auth.signup.business.inputs.agree' }, { terms: <Typography.Link href='https://weststeincard.com/Privacy_Policy_18_03_2025.pdf' target='_blank'>{t({ id: 'screens.auth.signup.buttons.privacy' })}</Typography.Link> })}
        </Checkbox>
      </Form.Item>
      <Form.Item rules={[
        {
          validator: (_, value) =>
            value ? Promise.resolve() : Promise.reject(new Error(t({ id: 'schemas.new.required-field' }))),
        },
      ]} valuePropName="checked" name="termsAndConditions">
        <Checkbox id='btn__checkbox'>
          {t({ id: 'screens.auth.signup.business.inputs.agree' }, { terms: <Typography.Link href='https://weststeincard.com/PAYMENT%20ACCOUNT%20AND%20CARD%20TERMS%20AND%20CONDITIONS.pdf' target='_blank'>{t({ id: 'openAccount.modal.link.termsConditions' })}</Typography.Link> })}
        </Checkbox>
      </Form.Item>
      <Form.Item>
        <Button color="primary" variant='solid' htmlType='submit' block>{t({ id: 'buttons.signup' })}</Button>
      </Form.Item>
    </Form>
  )
}